/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
import ContractTable from "./ContractTable";
import React from "react";

const ContractTab = (props) => {
    const {
        contractorId,
        supplierId,
        bodyForExport,
        setBodyForExport,
        searchElement,
        setSearchElement,
        search,
        setSearch,//Searching filter active
        setSimpleSearch,
        setCriteria,
        selectedList,
        setSelectedList,
        isAllChecked,
        setIsAllChecked,
        modified,
        setModified,
        setDeleteContractShow
    } = props;

    return (
        <>
            <ContractTable
                contractorId={contractorId}
                supplierId={supplierId}
                searchElement={searchElement}
                setSearchElement={setSearchElement}
                search={search}
                setSearch={setSearch}
                setSimpleSearch={setSimpleSearch}
                selectedList={selectedList}
                setSelectedList={setSelectedList}
                isAllChecked={isAllChecked}
                setIsAllChecked={setIsAllChecked}
                setCriteria={setCriteria}
                modified={modified}
                setModified={setModified}
                bodyForExport={bodyForExport}
                setBodyForExport={setBodyForExport}
                setDeleteContractShow={setDeleteContractShow}
            />

        </>
    );
};
export default ContractTab;
